import { Link } from "react-router-dom";
import { FAN_FAVOURITE, FLAVOURS, shippingLabel } from "@/data/content";
import { bagsOf, findSixPack, money, perBagMoney, useShop } from "@/lib/shop";
import { AddButton } from "./AddButton";
import { ProductGallery } from "./ProductGallery";
import { Bundles } from "./Bundles";
import { Reveal } from "./Reveal";
import { FanBadge } from "./FanBadge";
import { Truck } from "lucide-react";
import { FREE_SHIP_MIN } from "@/data/content";

export { findSixPack };

const FlavourCard = ({ f, product, refPrice, i }) => {
  // Flavours not yet listed in Shopify show the same 6-pack price as the others
  const price = product?.price ?? refPrice;
  return (
  <Reveal delay={i * 0.07} data-testid={`product-card-${f.key}`} className="group relative flex flex-col rounded-[28px] bg-white border border-[#1B1530]/10 overflow-hidden">
    <ProductGallery f={f} />
    {f.key === FAN_FAVOURITE && <FanBadge className="absolute top-4 right-4 z-10" />}
    <div className="p-5 flex-1 flex flex-col">
      <h3 className="font-display text-2xl sm:text-3xl leading-none"><Link to={`/flavours/${f.key}`} data-testid={`product-link-${f.key}`} className="hover:text-[#FF5A5F] transition-colors after:absolute after:inset-x-0 after:top-0 after:h-[300px] sm:after:h-[340px]">{f.name}</Link></h3>
      <p className="text-sm text-[#4A4560] mt-2">{f.notes} · 6 bags</p>
      <div className="mt-auto pt-5 flex items-center justify-between gap-3">
        <span data-testid={`product-price-${f.key}`} className="font-display text-2xl">{price ? money(price) : "Soon"}</span>
        {price && <span className="text-xs font-semibold text-[#4A4560] text-right">{perBagMoney(price / 6)}/bag<br />{shippingLabel(price)}</span>}
      </div>
      <AddButton product={product} image={f.img || "/img/trio.jpg"} comingSoon={!product} testid={`add-to-cart-button-${f.key}`} className="mt-4 w-full" />
    </div>
  </Reveal>
  );
};

export const Shop = () => {
  const { products, status, shopUrl } = useShop();
  const refPrice = FLAVOURS.map((f) => findSixPack(products, f)?.price).find(Boolean);
  return (
    <section data-testid="product-grid-section" className="pb-24 lg:pb-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        {status === "error" && (
          <div data-testid="shop-error" className="rounded-2xl bg-white border border-[#1B1530]/10 p-6 mb-8">
            Couldn't load live products right now. <a className="text-[#FF5A5F] font-bold underline" href={shopUrl}>Shop directly on swolebears.ca</a>
          </div>
        )}
        <div data-testid="shop-free-shipping-banner" className="mb-10 flex items-center gap-3 rounded-2xl bg-[#7BD88F]/25 border border-[#7BD88F] px-5 py-4">
          <Truck className="h-6 w-6 shrink-0" />
          <p className="font-semibold">Free shipping on orders over ${FREE_SHIP_MIN}. <span className="font-normal text-[#4A4560]">The 24 and 50 bag boxes ship free.</span></p>
        </div>
        <Bundles />
        <h2 className="font-display text-3xl sm:text-4xl mt-20 mb-6">Flavour 6-packs</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {FLAVOURS.map((f, i) => <FlavourCard key={f.key} f={f} i={i} product={findSixPack(products, f)} refPrice={refPrice} />)}
        </div>
      </div>
    </section>
  );
};
